import { get} from '../../http'

const path = '/api/units'

export default {
    index(params){
        return get(`${path}`, params)
    }
}
